import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download/69b3b24f8d51a300140dcd15/nobimed_ai/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69b3b24f8d51a300140dcd15/nobimed_ai/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/69b3b24f8d51a300140dcd15/nobimed_ai/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/ubuntu/download/69b3b24f8d51a300140dcd15/nobimed_ai/src/contexts/ThemeContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b3b24f8d51a300140dcd15/nobimed_ai/src/styles/tailwind.css");
